import { FormProvider, useForm } from 'react-hook-form';

import Button from '@/components/Button';
import useSendData from '@/hooks/useSendData';
import { FormError, FormInput } from '@/components/form';

import LoadingSVG from '@/svg/loading.svg';

export default function Newsletter() {
  const {
    sendData,
    state: { error: feedbackError, result: newsletterResult },
  } = useSendData({
    endpoint: '/api/create-community-lead',
  });
  const methods = useForm();
  const {
    formState: { isSubmitting },
    handleSubmit,
  } = methods;

  const onSubmit = async (values) => sendData(values);

  return (
    <div className="bg-haiti py-10 px-6 lg:py-16 lg:px-20 rounded-lg">
      <FormProvider {...methods}>
        <div className="max-w-3xl">
          <h2 className="font-bold text-2xl md:text-3xl lg:text-4xl leading-snug">
            Stay up to date with GraphQL
          </h2>
          <p className="mt-5 mb-6">
            Sign up to our periodic newsletter on the fascinating world of
            Content Federation, Microservices, Composable Architectures, APIs,
            and GraphQL.
          </p>

          {newsletterResult ? (
            <p className="text-shamrock text-[13px] flex items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-1"
              >
                <path
                  d="M8.00004 14.6667C4.31804 14.6667 1.33337 11.682 1.33337 8.00004C1.33337 4.31804 4.31804 1.33337 8.00004 1.33337C11.682 1.33337 14.6667 4.31804 14.6667 8.00004C14.6667 11.682 11.682 14.6667 8.00004 14.6667ZM7.33537 10.6667L12.0487 5.95271L11.106 5.01004L7.33537 8.78137L5.44937 6.89537L4.50671 7.83804L7.33537 10.6667Z"
                  fill="#32C48D"
                />
              </svg>
              You&apos;re in!
            </p>
          ) : (
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex items-center flex-col lg:flex-row space-y-4 lg:space-y-0 w-full lg:w-auto"
            >
              <FormInput
                className="!mb-0 lg:h-11 text-haiti !placeholder-rock-blue w-full"
                name="name"
                label="Name"
                visuallyHiddenLabel
                placeholder="Your name"
                disabled={isSubmitting}
                required
              />

              <FormInput
                className="!mb-0 lg:ml-3 lg:h-11 text-haiti !placeholder-rock-blue w-full"
                name="email"
                placeholder="Your email address..."
                type="email"
                label="Email"
                visuallyHiddenLabel
                disabled={isSubmitting}
                required
                validation={{
                  pattern: {
                    value: /^\S+@\S+$/i,
                    message: 'Invalid email',
                  },
                }}
              />

              <Button
                type="submit"
                colour="pink"
                disabled={isSubmitting}
                className="lg:ml-3 h-11 w-full lg:w-auto"
              >
                {isSubmitting && (
                  <LoadingSVG className="fill-current mr-2 w-6" />
                )}
                Subscribe
              </Button>
            </form>
          )}

          {feedbackError && (
            <FormError className="flex items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-1"
              >
                <path
                  d="M8.00004 14.6667C4.31804 14.6667 1.33337 11.682 1.33337 8.00004C1.33337 4.31804 4.31804 1.33337 8.00004 1.33337C11.682 1.33337 14.6667 4.31804 14.6667 8.00004C14.6667 11.682 11.682 14.6667 8.00004 14.6667ZM7.33337 10V11.3334H8.66671V10H7.33337ZM7.33337 4.66671V8.66671H8.66671V4.66671H7.33337Z"
                  fill="#E53E3E"
                />
              </svg>

              {feedbackError}
            </FormError>
          )}
        </div>
      </FormProvider>
    </div>
  );
}
